import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Center } from 'src/app/interfaces/center';
import { CenterService } from 'src/app/services/center.service';
import { ErrorService } from 'src/app/services/error.service';

@Component({
  selector: 'app-center',
  templateUrl: './center.component.html',
  styleUrls: ['./center.component.css']
})
export class CenterComponent implements OnInit {
  listCenters: Center[] = [];
  loading = false;

  constructor(
    private _centerService: CenterService,
    private toastr: ToastrService,
    private _errorService: ErrorService
  ) {}

  ngOnInit(): void {
    this.getListCenters();
  }

  getListCenters() {
    this.loading = true;

    this._centerService.getListCenters().subscribe({
      next: (data: Center[]) => {
        this.listCenters = data;
        this.loading = false;
      },
      error: (error) => {
        console.error('Error al obtener la lista de centros:', error);
        this._errorService.msjError(error);
        this.loading = false;
      }
    });
  }

  deleteCenter(id: number) {
    this.loading = true;
    this._centerService.deleteCenter(id).subscribe({
      next: () => {
        this.getListCenters();
        this.toastr.warning('El centro fue eliminado con exito', 'Centro eliminado');
      },
      error: (error) => {
        console.error('Error al eliminar el centro:', error);
        this._errorService.msjError(error);
        this.loading = false;
      }
    });
  }
}
